import axios from 'axios'
import config from './config'
import { store } from './store'
import { addFlashMessage, showLoader, hideLoader, logout } from './actions'

axios.defaults.baseURL = config.endpoints.API_URL

// Pendig Request counter
let pendingRequests = 0

// NOTE: 🔥 Loader component
// Now with support for multiple requests
// Calling setLoadingSpinner with TRUE will increment the pendingRequest counter and show the loader
// Calling setLoadingSpinner with FALSE will decrement the counter and hide the loader if the counter got to CERO.
const setLoadingSpinner = isLoading => {
  if (isLoading) {
    pendingRequests++
    store.dispatch(showLoader())
  } else if (pendingRequests > 0) {
    pendingRequests--
    if (pendingRequests <= 0) {
      store.dispatch(hideLoader())
    }
  }
}

const getReadableApiErrorMessage = err => {
  const fallbackMessage = 'Algo salio mal. Por favor, intenta mas tarde'
  const responseData = err && err.response ? err.response.data : null

  if (responseData && typeof responseData.message === 'string' && responseData.message.trim()) {
    return responseData.message.trim()
  }

  if (typeof responseData === 'string') {
    const contentMatch = responseData.match(/Content:\s*(.*)$/i)
    if (contentMatch && contentMatch[1] && contentMatch[1].trim()) {
      return contentMatch[1].trim()
    }

    if (responseData.includes('http') || responseData.length > 180) {
      return fallbackMessage
    }

    return responseData
  }

  return fallbackMessage
}

axios.interceptors.request.use(
  config => {
    setLoadingSpinner(true)

    const { auth } = store.getState()
    const valtoken = auth && 'accessToken' in auth ? `Valtoken ${auth.accessToken}` : ''

    config.headers = {
      Authorization: valtoken,
      accept: '*/*'
    }
    return config
  },
  err => err
)

axios.interceptors.response.use(
  res => {
    setLoadingSpinner(false)
    return res
  },
  err => {
    // NOTE: 🔥 Loader component
    setLoadingSpinner(false)
    const {
      request: { status = 0 },
      message = ''
    } = err
    const skipErrorMessage = err && err.config && err.config.skipErrorMessage
    if (status === 401 || message.includes('Network Error')) {
      store.dispatch(logout())
      if (!skipErrorMessage) {
        store.dispatch(addFlashMessage('Algo salió mal. Por favor, intentá más tarde'))
      }
      return Promise.reject(err)
    }
    if (!skipErrorMessage) {
      store.dispatch(addFlashMessage(getReadableApiErrorMessage(err)))
    }
    return Promise.reject(err)
  }
)

/*
 * Metadata
 */

export const getDocumentTypes = async () => {
  const url = '/metadatos/ObtenerValores?clave=TipoDocumento'
  return await axios.get(url)
}

export const getGenders = async () => {
  const url = '/metadatos/ObtenerValores?clave=Sexo'
  return await axios.get(url)
}

/*
 * Appointments
 */

export const getClinics = async data => {
  const url = '/turnos/clinicas'
  return await axios.get(url, { params: data })
}

export const getSpecialties = async data => {
  const url = '/turnos/especialidades'
  return await axios.get(url, { params: data })
}

export const getProfessionals = async data => {
  const url = '/turnos/profesionales'
  return await axios.get(url, { params: data })
}

export const posConfirmAppointment = async (data, firebaseToken, requestConfig = {}) => {
  const url = '/turnos/confirmar'
  return await axios.post(
    url,
    { ...data, ...(firebaseToken ? { firebaseToken } : {}) },
    requestConfig
  )
}

export const getAvailableAppointments = async data => {
  const url = '/turnos/disponibles'
  return await axios.get(url, { params: data })
}

export const getCancelReasons = async clinic => {
  const url = `/turnos/motivosBaja?clinica=${clinic}`
  return await axios.get(url)
}

export const cancelAppointment = async (appointment, clinic, reason) => {
  const url = '/turnos/cancelar'
  const params = {
    clinica: clinic,
    nroSolicitud: appointment,
    codigoMotivo: reason
  }
  return await axios.post(url, params)
}

/*
 * Patient
 */

export const getHealthInsurances = async () => {
  const url = '/pacientes/obrasSociales'
  return await axios.get(url)
}

export const getHealthInsurancePlans = async healthInsurance => {
  const url = `/pacientes/planes?obraSocial=${healthInsurance}`
  return await axios.get(url)
}

export const getPatientLogin = async request => {
  const url = '/pacientes/IniciarSesion'
  return await axios.get(url, { params: request })
}

export const getPatientByClinic = async request => {
  const url = '/pacientes/ObtenerPaciente'
  return await axios.get(url, { params: request })
}

export const patientSignUp = async params => {
  const url = '/pacientes/CrearPacienteMindware'
  return await axios.post(url, params)
}

/*
 * Auditoria
 */
export const logAuditAction = async data => {
  const url = `/Auditoria/RegistrarAccion`
  return await axios.post(url, data)
}

//Notifications

export const createNotification = async ({
  targetClientId,
  notificationTypeCode,
  mobileTitle,
  payload: { message, url: payloadUrl, isInternal }
}) => {
  const url = '/Notificaciones/Push'
  return await axios.post(url, {
    targetClientId,
    notificationTypeCode,
    mobileTitle,
    payload: { message, url: payloadUrl, isInternal }
  })
}
/**{
  "targetClientId": "1234567890",
  "notificationTypeCode": "message",
  "mobileTitle": "Aviso",
  "payload": {
    "message": "Tu trámite fue registrado",
    "url": "/detalle/tramite",
    "isInternal": "true"
  }
} */
